<div class="container-fluid fixed-top px-0 wow fadeIn" data-wow-delay="0.1s">
  <!--<div class="top-bar row gx-0 align-items-center d-none d-lg-flex transition-topbar"  [class.topbar-hidden]="!isTopBarShow">
        <div class="col-lg-6 px-5 text-start jos">
            <small><i class="fa fa-map-marker-alt me-2"></i>123 Street, New York, USA</small>
            <small class="ms-4"><i class="fa fa-envelope me-2"></i>info@example.com</small>
        </div>
        <div class="col-lg-6 px-5 text-end">
            <small>Follow us:</small>
            <a class="text-body ms-3" href=""><i class="fab fa-facebook-f"></i></a>
            <a class="text-body ms-3" href=""><i class="fab fa-twitter"></i></a>
            <a class="text-body ms-3" href=""><i class="fab fa-linkedin-in"></i></a>
            <a class="text-body ms-3" href=""><i class="fab fa-instagram"></i></a>
        </div>
    </div>-->

  <nav
    #navbar
    class="navbar navbar-expand-lg py-lg-0 px-lg-5 wow fadeIn"
    data-wow-delay="0.1s"
    [ngClass]="!isTopBarShow ? 'navbar-animation' : 'navbar-transparent'"
  >
    <a href="index.html" class="navbar-brand ms-4 ms-lg-0">
      <img
        src="assets/img/mykadainew.png"
        class="mykadai-logo"
        [ngClass]="!isTopBarShow ? 'd-block' : 'd-lg-none'"
      />
    </a>
    <button type="button" class="navbar-toggler me-4" (click)="toggleNavbar()">
      <span class="navbar-toggler-icon">
        <i
          class="bi bi-list h1"
          [ngClass]="isNavbarCollapsed ? 'text-black' : 'text-black'"
        ></i>
      </span>
    </button>
    <div
      [ngClass]="{ 'collapse navbar-collapse': true, show: !isNavbarCollapsed }"
      id="navbarCollapse"
    >
      <div class="navbar-nav ms-auto p-4 p-lg-0">
        <a routerLink="/" fragment="home" class="nav-item nav-link active"
          >Home</a
        >
        <a routerLink="/" fragment="about" class="nav-item nav-link"
          >About Us</a
        >
        <a routerLink="/" fragment="pricing" class="nav-item nav-link"
          >Pricing</a
        >
        <a routerLink="/" fragment="contact" class="nav-item nav-link"
          >Contact Us</a
        >
        <a
          *ngIf="customerContent"
          href="https://play.google.com/store/apps/details?id=cloud.varnik.mykadai&pcampaignid=web_share"
          target="_blank"
          class="nav-item nav-link"
        >
          <i class="fab fa-google-play fa-lg mr-2"></i>
          <span>Google Play</span>
        </a>
        <a *ngIf="customerContent" href="#" class="nav-item nav-link ml-2">
          <i class="fab fa-apple fa-lg mr-2"></i>
          <span>App Store</span>
        </a>
        <a
          *ngIf="!customerContent"
          [routerLink]="['/login']"
          class="nav-item nav-link ml-2"
        >
          <i class="fas fa-sign-in-alt fa-lg mr-2"></i>
          <span>Login</span>
        </a>
        <a class="nav-item nav-link" (click)="openManualFor()" role="button">
          <img
            src="assets/img/manual/images.png"
            alt="User Manual"
            class="manual-img"
          />
        </a>
      </div>
    </div>
  </nav>
</div>
